import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseIcon from '@mui/icons-material/Close';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const ACTIONS = {
  save:{label:'Save',workingLabel:'Saving…',variant:'contained',color:'primary',icon:SaveOutlinedIcon},
  cancel:{
    label:'Cancel',
    workingLabel:'Cancelling…',
    variant:'outlined',
    color:'inherit',
    icon:CloseIcon,
    sx:{
      color:'#475569',
      borderColor:'#cbd5e1',
      backgroundColor:'#f8fafc',
      boxShadow:'0 1px 2px rgba(15,23,42,.04)',
      '&:hover':{
        color:'#1e293b',
        borderColor:'#94a3b8',
        backgroundColor:'#f1f5f9',
        boxShadow:'0 2px 5px rgba(15,23,42,.08)',
      },
    },
  },
  send:{label:'Send',workingLabel:'Sending…',variant:'contained',color:'primary',icon:SendOutlinedIcon},
  edit:{label:'Edit',workingLabel:'Opening…',variant:'outlined',color:'primary',icon:EditOutlinedIcon},
  update:{label:'Update',workingLabel:'Updating…',variant:'contained',color:'primary',icon:UpdateOutlinedIcon},
  delete:{label:'Delete',workingLabel:'Deleting...',variant:'contained',color:'error',icon:DeleteOutlineIcon},
};

export default function ETVActionButton({
  action='save',
  loading=false,
  label,
  loadingLabel,
  disabled=false,
  startIcon,
  children,
  sx,
  ...buttonProps
}) {
  const config=ACTIONS[action] || ACTIONS.save;
  const Icon=config.icon;
  const text=children || (loading ? (loadingLabel || config.workingLabel) : (label || config.label));
  return <Button
    variant={config.variant}
    color={config.color}
    disabled={disabled || loading}
    startIcon={loading ? <CircularProgress size={16} color="inherit"/> : (startIcon || <Icon/>)}
    sx={{textTransform:'none',borderRadius:2.25,fontWeight:600,minHeight:40,...config.sx,...sx}}
    {...buttonProps}
  >{text}</Button>;
}
